import { z } from 'zod';

export const options = [
  'CALL_REASON',
  'OFFLINE_REASON',
  'REJECT_CALL_REASON',
  'TEMPNOTE_REASON',
  'NOTIFICATION_CALL_REASON',
  'OUTCOME',
  'TEMPNOTE_ALARM_TYPE',
  'CONNECTION_TYPE',
  'DEVICE_TYPE',
] as const;

export const OptionTypeSchema = z.enum(options);
export type OptionType = z.infer<typeof OptionTypeSchema>;

export const OptionSchema = z.object({
  id: z.string(),
  label: z.string(),
  value: z.string(),
  status: z.enum(['ACTIVE', 'INACTIVE']),
  type: OptionTypeSchema,
});

export type Option = z.infer<typeof OptionSchema>;
